// extracted by mini-css-extract-plugin
export default {"container":"dQ-z","topReviewHeading":"eQ-z","criticalReview":"fQ-z","favorableReview":"gQ-z","vsSeparator":"hQ-z"};